import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { SettingsProvider } from './hooks/useSettings';
import Dashboard from './pages/Dashboard';
import Bills from './pages/Bills';
import NewBill from './pages/NewBill';
import BillDetail from './pages/BillDetail';
import Receipts from './pages/Receipts';
import NewReceipt from './pages/NewReceipt';
import ReceiptDetail from './pages/ReceiptDetail';
import Settings from './pages/Settings';
import Clients from './pages/Clients';
import Login from './pages/Login';
import { authAPI } from './utils/api';
import toast from 'react-hot-toast';
import './App.css';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('bp_token');
  return token ? children : <Navigate to="/login" replace />;
}

function Layout({ children }) {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const username = localStorage.getItem('bp_user') || 'Admin';

  const handleLogout = async () => {
    try { await authAPI.logout(); } catch {}
    localStorage.removeItem('bp_token');
    localStorage.removeItem('bp_user');
    toast.success('Logged out');
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <nav className="sidebar" data-open={menuOpen}>
        <div className="sidebar-header">
          <span className="sidebar-logo">⚡</span>
          <span className="sidebar-title">BillPro</span>
          <button className="menu-close" onClick={() => setMenuOpen(false)}>✕</button>
        </div>
        <div className="nav-links">
          <NavLink to="/" end onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">📊</span> Dashboard
          </NavLink>
          <NavLink to="/bills" onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">🧾</span> Bills
          </NavLink>
          <NavLink to="/receipts" onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">💳</span> Receipts
          </NavLink>
          <NavLink to="/clients" onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">👥</span> Clients
          </NavLink>
          <NavLink to="/settings" onClick={() => setMenuOpen(false)}>
            <span className="nav-icon">⚙️</span> Settings
          </NavLink>
        </div>
        <div className="sidebar-footer">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 13, color: '#cbd5e1', fontWeight: 600 }}>👤 {username}</div>
              <div style={{ fontSize: 11, color: '#475569', marginTop: 2 }}>Administrator</div>
            </div>
            <button
              onClick={handleLogout}
              style={{ background: 'rgba(255,255,255,.08)', border: 'none', color: '#94a3b8', borderRadius: 6, padding: '6px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      {menuOpen && <div className="overlay" onClick={() => setMenuOpen(false)} />}
      <div className="main-area">
        <header className="topbar">
          <button className="hamburger" onClick={() => setMenuOpen(true)}>☰</button>
          <div className="topbar-title">Billing Management</div>
          <div className="topbar-actions">
            <NavLink to="/bills/new" className="btn-primary-sm">+ New Bill</NavLink>
          </div>
        </header>
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/bills" element={<Bills />} />
                  <Route path="/bills/new" element={<NewBill />} />
                  <Route path="/bills/:id" element={<BillDetail />} />
                  <Route path="/bills/:id/edit" element={<NewBill />} />
                  <Route path="/receipts" element={<Receipts />} />
                  <Route path="/receipts/new" element={<NewReceipt />} />
                  <Route path="/receipts/:id" element={<ReceiptDetail />} />
                  <Route path="/clients" element={<Clients />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </SettingsProvider>
  );
}